import React from 'react';
import { Drawer } from '@material-ui/core';
import useStyles from './useStyles';
import { ChevronLeft, Download } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
interface Props {
  open: boolean;
  onClose: () => void;
  matches: boolean;
  tab?: React.ReactNode;
  listTabValue: 'file' | 'annotation';
  onDownloadAll: () => void;
}

const ViewerRightDrawer: React.FC<Props> = ({
  open,
  children,
  onClose,
  matches = false,
  tab,
  listTabValue,
  onDownloadAll
}) => {
  const classes = useStyles();

  if (!matches)
    return (
      <>
        {tab}
        {children}
      </>
    );

  return (
    <Drawer
      className={classes['Viewer-Right-Drawer-root']}
      open={open}
      onClose={onClose}
      anchor="right"
      transitionDuration={200}
    >
      <div className="Viewer-Right-Drawer-Header">
        <div className="icon-group">
          <div className="top-cta" onClick={onClose}>
            <ChevronLeft size={24} color={colorSet.gray900} />
          </div>
          {listTabValue === 'file' && (
            <div>
              <CustomizedButton
                variant="text"
                size="large"
                color="primary"
                endIcon={<Download size={20} color={colorSet.primary500} />}
                onClick={onDownloadAll}
              >
                전체 다운로드
              </CustomizedButton>
            </div>
          )}
        </div>
        <CustomizedTypography
          variant="h4"
          fontWeight="500"
          color="textPrimary"
          gutterBottoms={6}
        >
          {listTabValue === 'file' ? '파일리스트' : '주석'}
        </CustomizedTypography>
        {tab}
      </div>
      {children}
    </Drawer>
  );
};

export default ViewerRightDrawer;
